export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-img shimmer"></div>
      <div className="skeleton-body">
        <div className="skeleton-line shimmer" style={{ width: '70%' }}></div>
        <div className="skeleton-line shimmer" style={{ width: '45%' }}></div>
        <div className="skeleton-line shimmer" style={{ width: '55%' }}></div>
      </div>
    </div>
  );
}

export function SkeletonStatCard() {
  return (
    <div className="skeleton-stat-card">
      <div className="skeleton-line shimmer" style={{ width: '50%', height: '14px', marginBottom: '12px' }}></div>
      <div className="skeleton-line shimmer" style={{ width: '70%', height: '32px', marginBottom: '8px' }}></div>
      <div className="skeleton-line shimmer" style={{ width: '40%', height: '12px' }}></div>
    </div>
  );
}

export function SkeletonRow() {
  return (
    <div className="skeleton-row">
      <div className="skeleton-circle shimmer"></div>
      <div style={{ flex: 1 }}>
        <div className="skeleton-line shimmer" style={{ width: '60%' }}></div>
        <div className="skeleton-line shimmer" style={{ width: '40%' }}></div>
      </div>
      <div className="skeleton-line shimmer" style={{ width: '80px', height: '28px' }}></div>
    </div>
  );
}
